<template>
    <component :is="template">
        <template v-if="ready">
            <v-card v-if="ready && product" v-intersect="{ handler: onIntersect, options: { threshold: [0, 1.0] } }" elevation="0" class="contents-area">
                <div class="mb-3">
                    <span v-for="(category, index) in categories" :key="category._id">
                        <span style="cursor: pointer" :class="index === categories.length - 1 ? 'font-weight-bold' : ''" @click="go(category?._id)">
                            {{ category.name }}
                        </span>
                        <span v-if="index !== categories.length - 1"> > </span>
                    </span>
                </div>
                <div class="contents-area__inner">
                    <v-row>
                        <!-- 상품 이미지 -->
                        <v-col cols="12" md="5">
                            <v-card outlined elevation="0" class="mb-md-4">
                                <v-responsive width="100%" max-width="480" class="mx-auto">
                                    <v-carousel height="auto" hide-delimiters show-arrows-on-hover :show-arrows="1 < product?.images?.length">
                                        <v-carousel-item v-for="(image, index) in product?.images || []" :key="index">
                                            <v-img :src="setImgSrc(image)" width="100%" max-width="480" contain :aspect-ratio="1 / 1" />
                                        </v-carousel-item>
                                    </v-carousel>
                                </v-responsive>
                            </v-card>
                        </v-col>

                        <!-- 상품정보 -->
                        <v-col cols="12" md="7">
                            <div class="pl-md-10">
                                <!-- 제품명 -->
                                <template>
                                    <div class="tit-wrap mb-20px mb-md-30px">
                                        <div class="tit tit--sm primary--text">
                                            <p v-html="product.name" />
                                        </div>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- 판매가 -->
                                <div class="py-10px py-md-16px">
                                    <template>
                                        <product-info-field label="판매가" class="font-weight-medium">
                                            <v-row no-gutters align="center">
                                                <v-col cols="auto">
                                                    <span v-if="product?.costPrice && product?.costPrice != product?.salePrice" class="font-size-14 line-height-1 text-decoration-line-through grey--text mr-8px">{{ product?.costPrice?.format?.() }}원</span>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <div class="d-inline-flex align-center font-size-18 font-size-md-20 line-height-1">
                                                        <b>{{ product?.salePrice?.format?.() }}</b
                                                        ><span class="font-size-16 ml-2px">원</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </product-info-field>
                                    </template>
                                </div>

                                <v-divider />

                                <div class="py-10px py-md-16px">
                                    <template>
                                        <product-info-field v-for="(item, index) in product.info" :label="item.name" :key="index">
                                            <span v-if="item">
                                                <b>{{ item.value }}</b>
                                            </span>
                                        </product-info-field>
                                    </template>
                                </div>

                                <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                <template v-if="!$vuetify.breakpoint.mobile && product.optionalProducts?.length && isSellable">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <optional-products v-model="carts" :product="product" />
                                    </div>
                                </template>

                                <!-- PC 수량 레이아웃 : 재고가 없을때-->
                                <template v-if="product.stock <= 0 || product.soldout">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <product-info-field label="수량" class="mt-4 font-weight-bold">품절</product-info-field>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- PC 수량 레이아웃 : 재고가 있을때 -->
                                <template v-if="!$vuetify.breakpoint.mobile && carts.length">
                                    <div class="py-10px py-md-16px">
                                        <cart-list v-model="carts" />
                                    </div>

                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <v-row align="center" class="row--small font-size-14">
                                            <v-col cols="3" md="2"> 총 합계 </v-col>
                                            <v-col cols="9" md="10">
                                                <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                                    <b class="primary--text">{{ parseInt(totalAmount).format() }}</b
                                                    ><span class="font-size-16 ml-2px">원</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="border-2" />

                                    <div class="py-10px py-md-16px">
                                        <v-row justify="end" align="center" class="row--x-small">
                                            <v-col>
                                                <v-btn block tile x-large color="primary" @click="order"><v-icon class="mr-10px">mdi-shopping-outline</v-icon>바로구매</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>

                    <v-divider class="d-none d-lg-block" />

                    <!-- 이전상품·다음상품 레이아웃 -->
                    <div class="pt-10px pt-md-16px">
                        <v-row class="row--x-small">
                            <v-col cols="auto">
                                <v-btn small outlined color="grey" :to="{ path: `/dshop/${path}/${prevProduct?._id}`, query: $route.query }" :disabled="!prevProduct">
                                    <span class="d-flex align-center grey--text text--darken-3"><v-icon small class="mr-4px mr-md-10px">mdi-chevron-left</v-icon>이전상품보기</span>
                                </v-btn>
                            </v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-btn small outlined color="grey" :to="{ path: `/dshop/${path}/${nextProduct?._id}`, query: $route.query }" :disabled="!nextProduct">
                                    <span class="d-flex align-center grey--text text--darken-3">다음상품보기<v-icon small class="ml-4px ml-md-10px">mdi-chevron-right</v-icon></span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-card>

            <v-divider />
            <!-- 상품 컨텐츠 -->
            <div class="overflow-hidden">
                <div class="contents-area">
                    <div class="contents-area__inner">
                        <div id="product-content" class="mt-n60px pt-60px"></div>
                        <v-responsive v-intersect="{ handler: onDetails, options: { threshold: [0, 1.0] } }" class="mb-10px">
                            <div>
                                <p v-html="product?.content"></p>
                            </div>
                        </v-responsive>
                    </div>
                </div>
            </div>
        </template>

        <!-- S: Mobile 하단 네비게이션 -->
        <template v-if="$vuetify.breakpoint.mobile && ready" slot="fab" slot-scope="{ showScroll, scrollTo }">
            <v-app-bar app bottom height="auto" color="transparent" elevation="1">
                <v-responsive class="overflow-visible">
                    <!-- Top 버튼 -->
                    <v-btn v-show="showScroll" fab absolute top right large tile color="primary" class="mt-n40px" @click="scrollTo(0, 0)">
                        <div class="pa-12px">
                            <v-icon size="20" class="my-n4px">mdi-chevron-up</v-icon>
                            <div class="font-size-14 font-weight-medium mb-6px">TOP</div>
                        </div>
                    </v-btn>

                    <v-card elevation="0">
                        <v-divider />
                        <div>
                            <v-btn @click="expand = !expand" :ripple="false" block color="grey lighten-4" height="28" slot="extension" active-class="no-active">
                                <v-icon v-show="!expand" color="grey">mdi-chevron-up</v-icon>
                                <v-icon v-show="expand" color="grey">mdi-chevron-down</v-icon>
                            </v-btn>
                        </div>

                        <v-expand-transition>
                            <v-responsive v-show="expand" elevation="0">
                                <v-divider />
                                <div class="pa-12px py-md-14px">
                                    <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                    <template v-if="product.optionalProducts?.length">
                                        <optional-products v-model="carts" :product="product" />
                                    </template>

                                    <template v-if="carts.length">
                                        <cart-list v-model="carts" />
                                    </template>

                                    <div class="mt-10px">
                                        <v-row align="center" class="row--small font-size-14">
                                            <v-col cols="3" md="2"> 총 합계 </v-col>
                                            <v-col cols="9" md="10" class="text-right">
                                                <div class="d-inline-flex align-center font-size-20">
                                                    <b class="primary--text">{{ parseInt(totalAmount).format() }}</b
                                                    ><span class="font-size-14 ml-2px">원</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                                <v-divider />
                            </v-responsive>
                        </v-expand-transition>

                        <div class="pa-12px py-md-14px">
                            <v-row class="row--x-small">
                                <v-col>
                                    <v-btn @click="order" x-large block color="primary">구매하기</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-responsive>
            </v-app-bar>
        </template>
        <!-- E: Mobile 하단 네비게이션 -->
        <kcb-cert ref="kcbCert" />
    </component>
</template>
<script>
import api from "@/api";
import { mdiChevronUp, mdiChevronDown, mdiChevronLeft, mdiChevronRight, mdiPlusCircleMultipleOutline, mdiCartOutline, mdiGiftOutline, mdiShoppingOutline } from "@mdi/js";

import LoginDialog from "@/components/client/login/login-dialog.vue";
import ProductInfoField from "@/components/client/shop/product/product-info-field.vue";
import CartList from "@/components/client/shop/product/cart-list.vue";
import OptionalProducts from "@/components/client/shop/product/optional-products.vue";
import ReviewList from "@/components/client/shop/product/review-list.vue";
import InquiryList from "@/components/client/shop/product/inquiry-list.vue";
import ExpectationList from "@/components/client/shop/product/expectation-list.vue";
import NaverPay from "@/components/plugins/naver/naver-pay.vue";
import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";

export default {
    components: {
        LoginDialog,
        ProductInfoField,
        CartList,
        OptionalProducts,
        ReviewList,
        InquiryList,
        ExpectationList,
        NaverPay,
        KcbCert
    },
    data() {
        return {
            // 아이콘
            mdiCartOutline,
            mdiGiftOutline,
            mdiChevronUp,
            mdiChevronDown,
            mdiChevronLeft,
            mdiChevronRight,
            mdiShoppingOutline,
            mdiPlusCircleMultipleOutline,

            ready: false,
            expand: false, // 모바일 하단 네비게이션 확장·축소

            product: null,
            prevProduct: null,
            nextProduct: null,

            carts: [], // 수량

            me: null,

            // 인터렉션 & 인터섹팅 데이터
            intersectingIndex: 0,
            intersecting: {
                isDetails: false,
                isExpectReview: false,
                isInquiry: false,
                isExchange: false,
            },

            offsetTop: 0,
            showAppBar: false,
            isIntersecting: false,
            isScroll: false,

            setting: null,

            path: null,

            purchase: null,
            tertiaryCategory: null,

            categories: [],
        };
    },
    async mounted() {
        await this.init();
        this.path = this.$route.path.split("/")[2];
    },
    methods: {
        async init() {
            try {
                this.carts = [];

                await this.getMe();
                await this.getSetting();
                await this.getProduct();
                await this.getCategory();

                // this.$store.dispatch("recent", { _id: this.product._id, thumb: this.product.thumb });

                this.ready = true;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        async getCategory() {
            try {
                this.categories = [{ name: "배송상품" }];

                let { category } = await api.v1.dshop.categories.get({ _id: this.product._category });

                this.categories.push(category);

                if (category._parents.length > 0) {
                    for (let i = 0; i < category._parents.length; i++) {
                        let { category: parent } = await api.v1.dshop.categories.get({ _id: category._parents[i] });
                        this.categories.push(parent);
                    }
                    this.categories.sort((a, b) => a.depth - b.depth);
                }
                // if (category.depth === 3) this.tertiaryCategory = category.name;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        async getProduct() {
            try {
                let { product, prev, next } = await api.v1.dshop.products.get({
                    _id: this.$attrs._product || this.$attrs.code,
                    params: { _category: this.$route.query?._category },
                });
                this.product = product;
                this.prevProduct = prev;
                this.nextProduct = next;

                if (product.type === "main" && this.isSellable && !product.optionalProducts.length) {
                    this.carts.push({ product, quantity: 1 });
                }
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        async getSetting() {
            try {
                let { setting } = await api.v1.shop.setting.get();
                this.setting = setting;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        async getMe() {
            try {
                if (this.accessToken) {
                    let { me } = await api.v1.me.profile.get();
                    this.me = me;
                }
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        setImgSrc(src) {
            // return `http://dev-giftcard.uxi.kr/${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },

        validate() {
            try {
                if (!this.accessToken) {
                    alert("로그인이 필요합니다.");
                    this.$router.push("/login");
                    return false;
                }
                if (this.carts.find((cart) => cart.quantity <= 0)) throw new Error("구매수량을 입력해주세요.");
                if (!this.isSellable) throw new Error("현재 판매되지 않는 상품입니다.");
                if ((this.me?.cash || 0) < this.totalAmount) throw new Error("캐시가 부족하여 구매하실 수 없습니다.");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async order() {
            this.certificate().then(() => {
                console.log("herer")
                if (this.validate()) {
                    this.$store.dispatch("pickup", { carts: this.carts });
                    this.$router.push(`/dshop/order`);
                }
            })
        },
        go(_category) {
            this.$router.push(`/dshop/products${_category ? `?_category=${_category}` : ""}`);
        },
        certificate() {
            return new Promise((resolve, reject) => {
                if (this.scope?.includes?.("cert")) resolve();
                else {
                    this.$refs.kcbCert.$off();
                    this.$refs.kcbCert.$on("input", async ({ _cert }) => {
                        await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
                        resolve();
                    });

                    this.$refs.kcbCert.open();
                }
            });
        },
        ///////////////////////////////////////////////////////////////////////////////////
        // 인터렉션
        ///////////////////////////////////////////////////////////////////////////////////
        onIntersect(entries, observer) {
            if (this.isIntersecting != entries[0].isIntersecting) this.isIntersecting = entries[0].isIntersecting;
        },
        onDetails(entries, observer) {
            if (this.intersecting.isDetails != entries[0].isIntersecting) this.intersecting.isDetails = entries[0].isIntersecting;
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.shop}`);
        },
        logon() {
            return !!this.$store.state.accessToken;
        },
        logoff() {
            return !this.$store.state.accessToken;
        },
        scope() {
            return this.$store.state.scope;
        },
        refreshToken() {
            return this.$store.state.refreshToken;
        },
        accessToken() {
            return this.$store.state.accessToken;
        },
        shippingAmount() {
            return this.product.shippingPrice;
        },
        totalAmount() {
            return this.carts.reduce((saleAmount, cart) => {
                return (saleAmount += cart.product.salePrice * cart.quantity);
            }, 0);
        },
        payload() {
            return this.$store.state.payload;
        },
        _user() {
            return this.$store.state.payload._user;
        },
        isSellable() {
            return this.product.onSale && this.product.onDisplay && !this.product.soldout && 0 < this.product.stock;
        },
    },
    watch: {
        async accessToken() {
            if (this.accessToken) {
                let { me } = await api.v1.me.profile.get();
                this.me = me;
            } else this.me = null;
        },

        carts: {
            handler() {
                for (let cart of this.carts) {
                    let quantity = parseInt(String(cart.quantity).replace(/[^0-9]/g, "") || 1);
                    let { stock } = cart.product;
                    if (stock && stock < quantity) {
                        alert("재고가 부족합니다");
                        cart.quantity = stock;
                    } else if (quantity < 1) cart.quantity = 1;
                    else cart.quantity = quantity;
                }
            },
            deep: true,
        },
        "$route.params._product"() {
            this.ready = false;
            this.init();
        },
        intersecting: {
            deep: true,
            handler() {
                if (this.intersecting.isDetails) this.intersectingIndex = 0;
                else if (this.intersecting.isExpectReview) this.intersectingIndex = 1;
                else if (this.intersecting.isInquiry) this.intersectingIndex = 2;
                else if (this.intersecting.isExchange) this.intersectingIndex = 3;
            },
        },
    },
};
</script>

<style scoped>
#contents .v-app-bar {
    height: auto !important;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .contents-area__inner {
        background-color: transparent;
    }
}
@media (min-width: 1200px) {
}
</style>